export default function getters() {
	return {
		getCurrentContract: state => state.currentContract,
		getCurrentPage: state => state.currentPage,
		getSelectedOffer: state => state.offer,
		getSelectedInsurerCode: state => state.insurerCode,
		getInsurerCodes: state => state.insurerCodes,
		getFormData:
			state =>
			({ parent, group, prop, index }) => {
				if (index !== undefined && index !== null) {
					if (
						state.contractingFormData[parent][group] === undefined ||
						state.contractingFormData[parent][group][index] === undefined ||
						state.contractingFormData[parent][group][index][prop] === undefined
					) {
						return null;
					}

					return state.contractingFormData[parent][group][index][prop];
				} else {
					if (
						state.contractingFormData[parent][group] === undefined ||
						state.contractingFormData[parent][group][prop] === undefined
					) {
						return null;
					}

					return state.contractingFormData[parent][group][prop];
				}
			},
		getCheckboxData: state => (prop, group, insurer) => {
			if (group !== undefined && insurer !== undefined) {
				return state.checkboxes[group][insurer][prop];
			} else {
				return state.checkboxes[prop];
			}
		},
		getCheckboxes: state => state.checkboxes,
		getAllFormData: state => state.contractingFormData,
		getOfferResponse: state => state.offerResponse,
		getBrokerageData: state => state.brokerageData,
		getFinancers: state => state.financers,
		getBanks: state => state.banks,
		getWsErrors: state => state.wsErrors,
		getDamageEvent: state => state.damageEvent,
		getDataByProp: state => prop => state[prop],
		getDisabledInputs: state => state.disabledInputs,
		getInited: state => state.inited,
        getRiskBearingAddress: state => state.contractingFormData.baseData?.riskBearingAddress,
        getContractSummary: state => state.summary,
	};
}
